import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LoadingSpinnerAlt from 'Components/LoadingSpinnerAlt';
import useStores from 'hooks/useStores';
import IInvoiceDocument from 'interfaces/service/Invoice/IInvoiceDocument';
import uiStore from 'stores/uiStore';


type ActionButtons = {
    invoice: IInvoiceDocument,
}

const ActionButtons = ({ invoice }: ActionButtons) => {
    const { t } = useTranslation();

    const [isDeleting, setisDeleting] = useState(false)
    const { withholdingsStore } = useStores()

    async function handleDelete() {
        if (invoice.IdWithholding) {
            uiStore.notifyWarning(t('this_invoice_is_part_of_a_withholding_and_cannot_be_deleted'))
            return
        }
        const confirmation = await uiStore.confirm({
            title: t('confirm_delete_title'),
            message: t('confirm_deletion'),
            confirmLabel: t('delete'),
            cancelLabel: t('cancel'),
            variant: 'danger',
        })
        if (!confirmation) return
        try {
            setisDeleting(true)
            await withholdingsStore.deleteInvoice(invoice)
        } finally {
            setisDeleting(false)
        }
    }
    return (
        <>
            {!invoice.IdWithholding && <>
                {isDeleting && <div className="d-inline-block action-button-loading-container">
                    <LoadingSpinnerAlt />
                </div>}
                {!isDeleting && <OverlayTrigger
                    placement={'top'}
                    overlay={
                        <Tooltip id={`tooltip-view`}>
                            {t('delete')}
                        </Tooltip>
                    }
                >
                    <i className="fas fa-trash cursor-pointer" onClick={handleDelete} />
                </OverlayTrigger>}
            </>
            }
        </>
    )
}

export default ActionButtons